import Logo from "../../components/icons/Logo";
import Tap from "../../assets/img/Green-Touch-Icon.gif";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../context/DataProvider";
import { useCallback } from "react";
import Restaurant from "../../components/icons/NavIcons/Restaurant";
import Kitchen from "../../components/icons/NavIcons/Kitchen";
import CasualDining from "../../components/icons/NavIcons/CasualDining";
import { Header } from "../../components/Header";
import FoodCourt from "../../components/icons/NavIcons/FoodCourt";
import EmployeeDining from "../../components/icons/NavIcons/EmployeeDining";
import Buffet from "../../components/icons/NavIcons/Buffet";
import FoodTrucks from "../../components/icons/NavIcons/FoodTrucks";

const DiningPage = () => {
    const navigate = useNavigate();
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    return(
        <div className="page splash2 diningPage">
            <Header />
            <div className="page-header">On Site Dining</div>
            <div className="text-blocks">
                <div className="std-text">
                    Whether your property offers fine dining
                    restaurants, casual dining/food courts, grab n go,
                    room service, poolside/beachside food &
                    beverage service, club/lounge or a combination of
                    these, you need food & beverage management
                    solutions that meet all your needs for excellent
                    customer service and successful food & beverage
                    management.
                </div>
            </div>
            <div className="logo" onClick={()=>{
                _logEvent('click', "On-site Dining", "Agilysys");
                addFlow("Agilysys");
                navigate("/aboutus/agilysys");
            }}>
                <Logo />
            </div>
            <div className="dining-map">
                <div className="restaurant">
                    <Restaurant onClick={()=>{
                        _logEvent('click', "On-site Dining", "Restaurant");
                        addFlow("Restaurant");
                        navigate("restaurant", { relative: "path" })
                    }} />
                </div>
                <div className="kitchen">
                    <Kitchen onClick={()=>{
                        _logEvent('click', "On-site Dining", "Kitchen");
                        addFlow("Kitchen");
                        navigate("kitchen", { relative: "path" })
                    }} />
                </div>
                <div className="casual">
                    <CasualDining onClick={()=>{
                        _logEvent('click', "On-site Dining", "Casual Dining");
                        addFlow("Casual Dining");
                        navigate("casual", { relative: "path" })
                    }} />
                </div>
                <div className="food-court">
                    <FoodCourt onClick={()=>{
                        _logEvent('click', "On-site Dining", "Food Court");
                        addFlow("Food Court");
                        navigate("food-court", { relative: "path" })
                    }} />
                </div>
                <div className="employee-dining">
                    <EmployeeDining onClick={()=>{
                        _logEvent('click', "On-site Dining", "Employee Dining");
                        addFlow("Employee Dining");
                        navigate("employee-dining", { relative: "path" })
                    }} />
                </div>
                <div className="buffet">
                    <Buffet onClick={()=>{
                        _logEvent('click', "On-site Dining", "Buffet");
                        addFlow("Buffet");
                        navigate("buffet", { relative: "path" })
                    }} />
                </div>
                <div className="food-trucks">
                    <FoodTrucks onClick={()=>{
                        _logEvent('click', "On-site Dining", "Food Trucks");
                        addFlow("Food Trucks");
                        navigate("food-trucks", { relative: "path" })
                    }} />
                </div>
            </div>
            {/*
            <div className="restaurant-link link" onClick={()=>{
                _logEvent('click', "On-site Dining", "Restaurant");
                addFlow("Restaurant");
                navigate("restaurant", { relative: "path" })}}/>
            <div className="restaurant-link2 link" onClick={()=>{
                _logEvent('click', "On-site Dining", "Restaurant");
                addFlow("Restaurant");
                navigate("restaurant", { relative: "path" })}}/>    
            <div className="kitchen-link link" onClick={()=>{
                _logEvent('click', "On-site Dining", "Kitchen");
                addFlow("Kitchen");
                navigate("kitchen", { relative: "path" })}}/>
            <div className="dining-link link" onClick={()=>{
                _logEvent('click', "On-site Dining", "Casual Dining");
                addFlow("Casual Dining");
                navigate("casual", { relative: "path" })}}/>
            */}
            <div className="tap">
                <img src={Tap} alt="" />
                <div className="tap-prompt">
                    Tap on each section of the map{'\n'}
                    To drill into the details
                </div>
            </div>
        </div>
    )
}

export default DiningPage;